import { render, staticRenderFns } from "./preformatted-editor.vue?vue&type=template&id=6afa6c60&scoped=true&"
import script from "./preformatted-editor.ts?vue&type=script&lang=ts&"
export * from "./preformatted-editor.ts?vue&type=script&lang=ts&"
import style0 from "./preformatted-editor.scss?vue&type=style&index=0&id=6afa6c60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afa6c60",
  null
  
)

export default component.exports